
import { defineComponent } from 'vue';
import { pdfComposition } from '../services';

import pdf from './pdf.vue';
import LyraAsset from '../../lyra/components/lyra-asset.vue';

export default defineComponent({
    components: {
    pdf,
    LyraAsset
},
    props: {
        source: {
            type: String,
            default: ''
        },
        controls: {
            type: Boolean,
            default: true
        },
        scale: {
            type: Number,
            default: 1
        },
        pdfWidth: {
            type: Number,
            default: 1024
        },
        pdfHeight: {
            type: Number,
            default: 600
        },
        goBackIcon: {
            type: String,
            default: ''
        }
    },
    setup() {
        return { ...pdfComposition() }
    },
})
